const globals = {
	breakpoint: 760
};

export default globals;